import { useCallback } from 'react';

export default (onClose: any) => {
  return useCallback(() => {
    onClose();
  }, [onClose]);
};
